// 🌐 Übersetzungen für die V3Tax App
export const translations = {
  de: {
    // Allgemeine UI-Elemente
    language: "Sprache",
    analyze: "Analysieren",
    calculate: "Berechnen",
    walletConnected: "Wallet Verbunden",
    connectWallet: "Wallet Verbinden",
    editMode: "Bearbeitungsmodus",
    applyChanges: "Änderungen übernehmen",
    cancel: "Abbrechen",
    save: "Speichern",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolgreich",
    reload: "neu berechnen",
    mainWallet: "Main Wallet",
    vedelegate: "veDelegate",
    plan: "Plan",
    
    // Navigation & Header
    home: "Startseite",
    analysis: "Analyse",
    settings: "Einstellungen",
    export: "Export",
    myWallets: "Meine Wallets",
    manageActiveWallets: "Verwalte aktive Wallets",
    "wallet.veworld.deepLinkDescription": "Direkter Login über die VeWorld App",
    "wallet.veworld.qrCodeDescription": "QR-Code mit VeWorld scannen",
    
    // Steuer-Tabellen
    taxSummary: "Steuerübersicht",
    totalProfit: "Gesamtgewinn",
    taxableProfit: "Steuerpflichtiger Gewinn",
    /** Kurzbezeichnung für Tabellenköpfe / Mobile */
    taxableProfitShort: "Steuerl. G/V",
    nonTaxableProfit: "Nicht steuerpflichtiger Gewinn",
    holdingPeriod: "Haltedauer",
    purchasePrice: "Kaufpreis",
    salePrice: "Verkaufspreis",
    profit: "Gewinn",
    loss: "Verlust",
    
    // Token-spezifische Begriffe
    vet: "VET",
    vtho: "VTHO", 
    b3tr: "B3TR",
    vip180: "VIP-180",
    nft: "NFT",
    token: "Token",
    vip180TokenTransfers: "VIP-180 Token Transfers",
    allTokens: "Alle Tokens",
    allTypes: "Alle Typen",
    showMainWallet: "Main Wallet anzeigen",
    showDelegateWallet: "VeDelegate-Wallet anzeigen",
    transfersShown: "Transfers angezeigt",
    ofTotal: "von insgesamt",
    noTokenTransfers: "Keine Token Transfers gefunden",
    transfersLoading: "Transfers werden geladen",
    
    // Transaktionstypen
    received: "Empfangen",
    sent: "Gesendet",
    swap: "Swap",
    swapIn: "Swap Eingang",
    swapOut: "Swap Ausgang",
    airdrop: "Airdrop",
    governanceReward: "Governance Reward",
    stakingReward: "Staking Belohnung",
    mint: "Mint",
    sale: "Verkauf",
    purchase: "Kauf",
    
    // Steuerliche Kategorien
    disposalTransactions: "Veräußerungsgeschäfte (§23 EStG)",
    otherIncome: "Sonstige Einkünfte (§22 Nr. 3 EStG)",
    generated: "Generiert",
    stakingRewards: "Staking Rewards",
    fees: "Gebühren",
    none: "Keine",
    freigrenze: "Freigrenze",
    gesamt: "Gesamt",
    steuerlicheHinweise: "Veräußerungsgeschäfte und sonstige Einkünfte werden getrennt besteuert",
    
    // Länder-spezifische Steuerkategorien
    disposalTransactionsDE: "Veräußerungsgeschäfte (§23 EStG)",
    otherIncomeDE: "Sonstige Einkünfte (§22 Nr. 3 EStG)",
    disposalTransactionsGR: "Capital Gains (Disposal Transactions)",
    otherIncomeGR: "Income from Staking, Airdrops, Rewards",
    disposalTransactionsIT: "Capital Gains (Plusvalenze)",
    otherIncomeIT: "Income from Staking, Airdrops, Rewards (Redditi)",

    disposalTransactionsGeneric: "Capital Gains / Disposal Transactions",
    otherIncomeGeneric: "Other Income (Staking, Airdrops, Rewards)",
    
    // FIFO-spezifische Begriffe
    fifoAssignment: "FIFO-Zuordnung",
    used: "Verwendet",
    receivedOn: "Erhalten am",
    holdingDuration: "Haltedauer",
    purchasePriceEUR: "Einstand €",
    salePriceEUR: "Verkauf €",
    profitEUR: "Gewinn €",
    taxable: "Steuerpflichtig",
    holdingPeriodOver365Days: "Haltefrist > 365 Tage?",
    markAsNonTaxable: "Als nicht steuerpflichtig markieren (Haltefrist > 365 Tage)",
    note: "💡 Hinweis: Markiere Inflows mit \"Haltefrist > 365 Tage\" als nicht steuerpflichtig",
    
    // Warnungen & Hinweise
    warning: "Warnung",
    attention: "Achtung",
    incomplete: "Nicht vollständig gedeckt: Es fehlen Token zur vollständigen Deckung.",
    timeInconsistent: "⚠️ Achtung: Token wurde nach dem Swap/Mint erhalten! Zeitlich inkonsistent.",
    
    // Export & Daten
    exportData: "Daten exportieren",
    exportCSV: "CSV exportieren",
    exportPDF: "PDF exportieren",
    download: "Herunterladen",
    all: "aller",
    taxData: "Steuerdaten",
    noDataToExport: "Keine Daten zum Exportieren vorhanden.",
    markManually: "Manuell markieren",
    noSaleDataAvailable: "Keine Daten für Verkauf verfügbar",
    noMatchingPurchaseFound: "Kein passender Kauf gefunden",
    taxAssessmentForSale: "Steuerliche Bewertung für Verkauf",
    tip: "Tipp",
    markNftSalesAsNonTaxable: "Markiere NFT-Verkäufe als \"nicht steuerpflichtig\" wenn sie länger als 365 Tage gehalten wurden",
    imprint: "Impressum",
    legalNotice: "Angaben gemäß § 5 TMG",
    allRightsReserved: "Alle Rechte vorbehalten",
    
    // VTHO-spezifische Begriffe
    vthoOverview: "VTHO Übersicht",
    generatedVtho: "Generiertes VTHO",
    stargateStaking: "Stargate Staking",
    taxTransactions: "Steuer-Transaktionen",
    gasConsumption: "Gasverbrauch",
    
    // Tabellen-Header
    type: "Typ",
    comment: "Kommentar",
    to: "bis",
    
    // VTHO-spezifische Begriffe
    vthoOtherIncome: "Sonstige Einnahmen (§)",
    unburnedTransactions: "Nicht verbrannte Transaktionen",
    fees: "Fees",
    burnedAsGas: "Verbrannt als Gas (Werbungskosten möglich)",
    generated: "Generiert",
    fromVetHolding: "aus VET Holding",
    vetHoldingBalanceLabel: "VET Bestand:",
    dailyCalculatedEarnings: "Täglich berechnete Erträge",
    receivedPlusGeneratedMinusUsedMinusSent: "Empf. + Gen. – Genutzt – Gesendet",
    
    // Steuerliche Hinweise
    stargateUpgradeInfo: "Seit dem 01.07.2025 (Stargate-Upgrade) erfolgt die VTHO-Erzeugung nur noch durch aktives NFT-Staking.",
    lastUpdate: "Letztes Update",
    taxNotes: "Steuerliche Hinweise",
    receivedTaxNote: "Gilt als sonstige Einnahme zum Tageskurs (€).",
    usedTaxNote: "VTHO (\"Fees\") können als Werbungskosten gelten.",
    generatedTaxNote: "Modellhafte Erträge aus VET Holding – steuerpflichtig.",
    syntheticVthoExplainTitle: "Warum so viele „Generiert“-Zeilen?",
    syntheticVthoExplainBody:
      "Das sind keine Blockchain-Transaktionen. VTHO aus VET-Holding wird zeitanteilig modelliert (0,000432 VTHO pro VET und Tag). Sobald VTHO die Wallet verlässt – z. B. als Gas – wird der Zeitraum davor abgeschlossen, damit die FIFO-Berechnung den bis dahin entstandenen VTHO kennt. Jeder Abschnitt ist eine steuerliche Einkommenszeile; die Spalte „Steuerl. G/V“ zeigt hier den Einkommenswert (Marktwert), nicht einen Veräußerungsgewinn.",
    syntheticVthoExplainCount: "Synthetische Abschnitte in diesem Jahr",
    syntheticVthoIncomeColumnHint: "Einkommen (§22)",
    balanceTaxNote: "Empfangen + Generiert – Genutzt – Gesendet",
    
    // NFT-spezifische Begriffe
    nftName: "NFT Name",
    tokenId: "Token ID",
    project: "Projekt",
    contract: "Contract",
    currency: "Währung",
    
    // Zeit & Datum
    days: "Tage",
    date: "Datum",
    time: "Zeit",
    price: "Preis",
    for: "für",
    in: "im",
    
    // Status & Icons
    yes: "Ja",
    no: "Nein",
    pending: "Ausstehend",
    completed: "Abgeschlossen",
    failed: "Fehlgeschlagen",
    
    // Balance & Verifikation
    balance: "Balance",
    balanceVerification: "Balance Verifikation",
    expectedBalance: "Erwartete Balance",
    actualBalance: "Tatsächliche Balance",
    difference: "Differenz",
    blockchainBalanceCheck: "Blockchain-Balance-Abgleich",
    checkingWalletBalance: "Prüfe aktuelle Wallet-Balance",
    updatingBalanceCheck: "Aktualisiere Balance-Abgleich",
    fifoPoolsUpdated: "FIFO-Pools aktualisiert",
    calculated: "Berechnet",
    blockchain: "Blockchain",
    usedGasFees: "Verwendete Gas-Fees",
    deviation: "Abweichung",
    stargateCorrection: "Stargate-Korrektur berücksichtigt",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    noRelevantDeviation: "Keine relevante Abweichung – steuerlich direkt verwendbar",
    slightDeviation: "Leichte Abweichung (1–3 % und über 10 €) – steuerlich meist unproblematisch, aber prüfbar",
    criticalDeviation: "Abweichung über 3 % und über 500 € – steuerlich kritisch, bitte FIFO-Pools überprüfen",
    balanceError: "Fehler bei /live-balance",
    connectionError: "Verbindungsfehler",
    
    // Edit-Modus spezifische Begriffe
    editModeActive: "Bearbeitungsmodus aktiv",
    manualClassification: "Manuelle Klassifizierung",
    changeClassification: "Klassifizierung ändern",
    originalClassification: "Ursprüngliche Klassifizierung",
    newClassification: "Neue Klassifizierung",
    
    // Nicht-steuerpflichtige Markierungen
    markNonTaxable: "Als nicht steuerpflichtig markieren",
    unmarkNonTaxable: "Steuerpflichtig markieren",
    nonTaxableInflow: "Nicht-steuerpflichtiger Inflow",
    nonTaxableSale: "Nicht-steuerpflichtiger Verkauf",
    
    // Debug & Entwickler
    debug: "Debug",
    developerMode: "Entwicklermodus",
    showDebugInfo: "Debug-Informationen anzeigen",
    hideDebugInfo: "Debug-Informationen ausblenden",
    
    // Fehlermeldungen
    errorLoadingData: "Fehler beim Laden der Daten",
    errorSavingData: "Fehler beim Speichern der Daten",
    errorCalculatingFifo: "Fehler bei der FIFO-Berechnung",
    errorExportingData: "Fehler beim Exportieren der Daten",
    
    // Erfolgsmeldungen
    dataLoadedSuccessfully: "Daten erfolgreich geladen",
    changesSavedSuccessfully: "Änderungen erfolgreich gespeichert",
    fifoCalculatedSuccessfully: "FIFO erfolgreich berechnet",
    dataExportedSuccessfully: "Daten erfolgreich exportiert",

    // Toasts (react-toastify) – zentral für korrekte Sprache
    toast: {
      geo: {
        blocked:
          "Standortzugriff für diese Website ist im Browser blockiert – Kauf abgebrochen. Für die steuerliche Bestimmung des Leistungsorts (EU-USt) benötigen wir zwei unabhängige Nachweise (z. B. IP-Land und GPS-Land). Bitte erlauben Sie den Zugriff auf den ungefähren Standort (Land) in den Browser-Einstellungen (z. B. Edge: Einstellungen → Websiteberechtigungen → Standort → Ihre Seite → „Zulassen\") und starten Sie den Kauf erneut.",
        permissionDenied:
          "Standortzugriff verweigert – Kauf abgebrochen. Bitte erlauben Sie den Standortzugriff in den Browser-Einstellungen und versuchen Sie es erneut.",
        unavailable:
          "Standortbestimmung derzeit nicht verfügbar – Kauf abgebrochen. Bitte prüfen Sie Ihre Browser-/Geräteeinstellungen und versuchen Sie es erneut.",
        timeout:
          "Standortbestimmung hat zu lange gedauert – Kauf abgebrochen. Bitte prüfen Sie Ihre Verbindung/Empfang und versuchen Sie es erneut.",
        backendUnreachable:
          "Länderverifikation fehlgeschlagen – Kauf abgebrochen. Der Standortdienst ist momentan nicht erreichbar. Bitte später erneut versuchen.",
        policyViolation:
          "Für die Bestimmung des Leistungsorts nach EU-USt-Recht benötigen wir mindestens zwei unabhängige Standortnachweise (IP + GPS). Bitte erlauben Sie den Standortzugriff und versuchen Sie es erneut.",
        unknown:
          "Standortverifikation fehlgeschlagen – Kauf abgebrochen. Bitte prüfen Sie Ihre Einstellungen und versuchen Sie es erneut.",
        infoBeforePrompt:
          "Hinweis: Wir verifizieren ausschließlich Ihr Land für steuerliche Zwecke. Exakte Koordinaten werden nicht gespeichert.",
      },
      noTaxYearSelected: "Kein Steuerjahr erkannt – bitte ein Jahr wählen.",
      datasetIdMissing: "Dataset-ID fehlt – bitte erneut versuchen.",
      addressCopied: "Adresse kopiert",
      addressCopiedExclaim: "Adresse kopiert!",
      hashCopied: "Hash kopiert!",
      copyFailed: "Kopieren fehlgeschlagen",
    },
    
    // Platzhalter & Standardwerte
    unknown: "Unbekannt",
    notAvailable: "Nicht verfügbar",
    loadingData: "Daten werden geladen...",
    noDataAvailable: "Keine Daten verfügbar",
    
    // Tooltips & Hilfetexte
    help: "Hilfe",
    tooltip: "Tooltip",
    moreInfo: "Weitere Informationen",
    clickForDetails: "Klicken für Details",
    
    // Bestätigungen
    confirm: "Bestätigen",
    confirmDelete: "Löschen bestätigen",
    confirmSave: "Speichern bestätigen",
    confirmCancel: "Abbrechen bestätigen",
    
    // Filter & Suche
    filter: "Filter",
    search: "Suchen",
    clearFilter: "Filter löschen",
    applyFilter: "Filter anwenden",
    
    // Sortierung
    sort: "Sortieren",
    sortBy: "Sortieren nach",
    ascending: "Aufsteigend",
    descending: "Absteigend",
    
    // Paginierung
    page: "Seite",
    of: "von",
    itemsPerPage: "Einträge pro Seite",
    showAll: "Alle anzeigen",
    
    // Statistiken
    statistics: "Statistiken",
    total: "Gesamt",
    average: "Durchschnitt",
    minimum: "Minimum",
    maximum: "Maximum",
    count: "Anzahl",
    
    // Zeiträume
    today: "Heute",
    yesterday: "Gestern",
    thisWeek: "Diese Woche",
    thisMonth: "Dieser Monat",
    thisYear: "Dieses Jahr",
    lastYear: "Letztes Jahr",
    
    // Währungen
    euro: "Euro",
    usd: "US-Dollar",
    currency: "Währung",
    
    // Steuerjahre
    taxYear: "Steuerjahr",
    selectTaxYear: "Steuerjahr auswählen",
    
    // Wallet & Adressen
    wallet: "Wallet",
    walletAddress: "Wallet-Adresse",
    address: "Adresse",
    copyAddress: "Adresse kopieren",
    
    // Transaktionen
    transaction: "Transaktion",
    transactions: "Transaktionen",
    transactionHash: "Transaktions-Hash",
    /** Kompakter Kopf in Rohdaten-Tabellen */
    txHashColumn: "TX-Hash",
    blockNumber: "Block-Nummer",
    gasFee: "Gas-Gebühr",
    blockchainTransactions: "Blockchain-Transaktionen",
    loadingTransactions: "Transaktionen werden geladen",
    noTransactionsFound: "Keine Transaktionen gefunden",
    pleaseAdjustFilters: "Bitte Filter oder Suchbegriff anpassen.",
    amount: "Menge",
    /** Liquiditäts-Tabelle: Spaltenköpfe */
    lpDepositColumn: "Einzahlung",
    lpWithdrawColumn: "Auszahlung",
    tokensColumnSub: "Token",
    recipient: "Empfänger",
    sender: "Sender",
    source: "Quelle",
    /** Börsen-Import-Tabelle */
    exchange: "Quelle / Börse",
    exchangeKind: "Typ",
    quote: "Gegenwert",
    side: "Kauf / Verkauf",
    txid: "TXID",
    fee: "Gebühr",
    feeAsset: "Gebühren-Asset",
    quoteAmount: "Gegenwert-Betrag",
    exchangeSource: "Quelle",
    exchangeType: "Art",
    exchangeBuySell: "Kauf / Verkauf",
    
    // Validierung
    validation: "Validierung",
    valid: "Gültig",
    invalid: "Ungültig",
    required: "Erforderlich",
    optional: "Optional",
    
    // Berechtigungen
    permissions: "Berechtigungen",
    accessDenied: "Zugriff verweigert",
    insufficientPermissions: "Unzureichende Berechtigungen",
    
    // Netzwerk
    network: "Netzwerk",
    mainnet: "Mainnet",
    testnet: "Testnet",
    connectionStatus: "Verbindungsstatus",
    connected: "Verbunden",
    disconnected: "Getrennt",
    
    // Synchronisation
    sync: "Synchronisation",
    syncing: "Synchronisiere...",
    syncComplete: "Synchronisation abgeschlossen",
    syncFailed: "Synchronisation fehlgeschlagen",
    
    // Cache & Performance
    cache: "Cache",
    clearCache: "Cache löschen",
    refresh: "Aktualisieren",
    reload: "Neu laden",
    
    // Einstellungen
    settings: "Einstellungen",
    preferences: "Einstellungen",
    appearance: "Erscheinungsbild",
    darkMode: "Dunkler Modus",
    lightMode: "Heller Modus",
    
    // Benachrichtigungen
    notifications: "Benachrichtigungen",
    notificationSettings: "Benachrichtigungseinstellungen",
    enableNotifications: "Benachrichtigungen aktivieren",
    disableNotifications: "Benachrichtigungen deaktivieren",
    
    // Hilfe & Support
    help: "Hilfe",
    support: "Support",
    documentation: "Dokumentation",
    contact: "Kontakt",
    feedback: "Feedback",
    
    // Über die App
    about: "Über",
    version: "Version",
    credits: "Credits",
    license: "Lizenz",
    privacyPolicy: "Datenschutzrichtlinie",
    termsOfService: "Nutzungsbedingungen",
    
    // Edit Mode
    activate: "aktivieren",
    leave: "verlassen",
    totalPurchasePrice: "Einstand gesamt",
    
    // Landing Page (App.jsx)
    ultimateAioWalletAnalysis: "VeChain: Ultimate AIO Wallet Analysis",
    enterWalletAddressDescription: "Geben Sie Ihre VeChain Wallet-Adressen ein, um Ihr steuerpflichtiges Einkommen zu ermitteln.",
    pricingAndFeatures: "Preise & Features",
    selectPlan: "Plan auswählen",
    selectYear: "Jahr auswählen",
    selectPaymentMethod: "Zahlungsmethode auswählen",
    selectResidence: "Steuerregeln",
    vetPayment: "VET (VeChain)",
    creditCardPayment: "Kreditkarte",
    analyze: "Analysieren",
    analyzing: "Analysiere...",
    buy: "Kaufen",
    fieldRequired: "Feld erforderlich",
    walletAlreadyAnalyzed: "Wallet bereits analysiert",
    addWalletToList: "Wallet zur Liste hinzufügen",
    insertNextWalletHint: "Nächste VeChain Wallet für Analyse eingeben",
    selectedWallets: "Ausgewählte Wallets",
         mainWallet: "Main Wallet",
    vedelegateWallet: "VEDELEGATE-WALLET",
    noWalletAnalyzedYet: "Noch keine Wallet analysiert",
    noVedelegateWalletDetected: "Keine veDelegate Wallet erkannt.",
    transactionOverview: "Transaktionsübersicht",
    transactions: "TRANSAKTIONEN",
    myWallets: "Meine Wallets",
    manageActiveWallets: "Aktive Wallets verwalten",
    analysisDashboard: "Analyse Dashboard",
    viewTransactionAnalysis: "Transaktionsanalyse anzeigen",
    legalNotices: "Rechtliche Hinweise",
    termsAndPrivacy: "AGB & Datenschutz",
    helpAndSupport: "Hilfe & Support",
    getHelpAndDocumentation: "Hilfe und Dokumentation",
    
    // Navigation & Menu
    dashboard: "Dashboard",
    overview: "Übersicht",
    summary: "Zusammenfassung",
    detailedView: "Detaillierte Ansicht",
    quickOverview: "Schnellübersicht",
    
    // Dashboard specific
    dashboardTitle: "Steuerübersicht Dashboard",
    dashboardSubtitle: "Alle berechneten Werte auf einen Blick",
    totalCalculatedValues: "Gesamtwerte aller Berechnungen",
    individualTableValues: "Einzelwerte der Tabellen",
    taxYearSummary: "Steuerjahr Zusammenfassung",
    profitOverview: "Gewinnübersicht",
    transactionSummary: "Transaktionsübersicht",
    calculatedProfits: "Berechnete Gewinne",
    totalTaxableAmount: "Gesamtsteuerpflichtiger Betrag",
    disposalTransactionsTotal: "Veräußerungsgeschäfte Gesamt",
    otherIncomeTotal: "Sonstige Einkünfte Gesamt",
    nftTransactions: "NFT Transaktionen",
    tokenTransactions: "Token Transaktionen",
    vetTransactions: "VET Transaktionen",
    vthoTransactions: "VTHO Transaktionen",
    b3trTransactions: "VIP-180 Token-Transaktionen",
    
    // Spezifische Bezeichnungen für Tax Tables
    generatedVthoAndStakingRewards: "Generierte VTHO und Stargate Staking Rewards",
    airdropsAndGovernanceRewards: "Airdrops und Governance Rewards",
    swaps: "Swaps",
    nftPurchasesAndSales: "NFT Käufe & Verkäufe",
    exchangeSells: "Verkäufe",
    
    // Balance Verifier
    balanceVerifier: {
      title: "Informationen zum Balance-Abgleich",
      statusLegend: "Status-Legende:",
      termExplanation: "Begriffserklärung:",
      tableHeaders: {
        token: "Token",
        onchain: "On-chain",
        onchainSub: "Wallet-Bestand",
        fifo: "FIFO",
        fifoSub: "(inkl. Börsen)",
        delta: "Δ",
        deltaSub: "(Differenz)",
        activity: "Aktivität",
        activitySub: "Turnover + Δ/Turnover",
        status: "Status",
        deltaBalance: "Δ%",
        deltaPctBalance: "Δ% Bestand",
        deltaBalanceSub: "(Bestand)",
        deltaActivity: "Δ%",
        deltaActivitySub: "(Aktivität)",
        rating: "Bewertung"
      },
      labels: {
        walletOnly: "Nur Wallets",
        relativeToWalletOnly: "relativ zu FIFO (nur Wallets)",
        fifoFullShort: "Full:"
      },
      status: {
        match: "✓ Match",
        onchainHigher: "↑ On-chain höher",
        fifoHigher: "↓ FIFO höher"
      },
      summary: {
        tokensCompared: "Token verglichen:",
        hidden: "ausgeblendet",
        matches: "Matches:",
        onchainHigher: "On-chain höher:",
        fifoHigher: "FIFO höher:"
      },
      actions: {
        recheck: "🔄 Neu prüfen",
        checking: "⏳ Prüfe..."
      },
      toggles: {
        cleanView: "Clean-View (ohne Dust)",
        includeStakedVet: "Stargate Staking VET einbeziehen"
      },
      terms: {
        onchainApi: "On-chain (API)",
        onchainReported: "On-chain (Reported)",
        fifoCalc: "FIFO (Berechnung)",
        fifoCalculated: "FIFO (Calculated)",
        deltaBalance: "Δ% (Bestand)",
        deltaDifference: "Δ (Differenz)",
        deltaActivity: "Δ% (Aktivität)",
        activityTurnover: "Turnover (Aktivität)",
        deltaTurnover: "Δ/Turnover",
        score: "Score (0–100)"
      },
      descriptions: {
        onchainApi: "Tatsächlicher Wallet-Bestand, live per Blockchain-API abgefragt (nur Wallets im Set).",
        onchainReported: "Aktueller Wallet-Kontostand, live über Blockchain-API abgefragt. Beinhaltet nur Wallets, keine Börsen.",
        fifoCalc: "Berechneter Bestand aus allen erfassten Events/Trades – inkl. Börsenbeständen aus CSV-Importen.",
        fifoCalculated: "Berechneter Endbestand aus allen erfassten Transaktionen (Trades, Transfers, Staking, Airdrops, NFTs). Dies ist die Grundlage der Steuerberechnung.",
        deltaBalance: "Prozentuale Abweichung zwischen API-Bestand und FIFO-Berechnung bezogen auf den Endbestand (kann bei kleinen Restbeständen stark verzerren).",
        deltaDifference: "Abweichung zwischen On-chain Snapshot und berechnetem FIFO-Bestand. Eine Abweichung kann durch fehlende Daten, Börsentransaktionen oder API-Limitationen entstehen.",
        deltaActivity: "Prozentuale Abweichung zwischen API-Bestand und FIFO-Berechnung relativ zur gesamten Aktivität (Turnover = Summe Zu-/Abgänge, ohne interne Transfers). Diese Kennzahl eignet sich besonders für eine robuste Qualitätsbewertung über die gesamte Historie.",
        activityTurnover: "Gesamtes Bewegungsvolumen des Tokens im Wallet-Set (Zugänge + Abgänge, ohne interne Umlagerungen).",
        deltaTurnover: "Zeigt die Abweichung zwischen On-chain und FIFO in % bezogen auf die gesamte Token-Bewegung (Turnover). So wird sichtbar, ob eine Differenz im Verhältnis zur Aktivität relevant ist.",
        score: "Qualitäts-Indikator zur Bewertung der Datenkonsistenz zwischen On-chain Snapshot und berechneter Historie. Der Score berücksichtigt sowohl Endbestand als auch Bewegungsvolumen."
      },
      legalNotice: {
        title: "⚠️ Rechtlicher Hinweis:",
        text: "Der Reconciliation-Score dient ausschließlich als technischer Daten- und Vollständigkeitsindikator. Er stellt keine steuerliche Beratung und keine Garantie für steuerliche Korrektheit dar. Für die steuerliche Verantwortung ist der Nutzer selbst verantwortlich."
      },
      hintTitle: "💡 Hinweis:",
      hintText: "Wenn FIFO höher ist als On-chain, ist das oft normal, wenn Token auf Börsen liegen (in FIFO enthalten, aber nicht in der Wallet-API sichtbar).",
      ratings: {
        na: "Keine Daten",
        great: "Sehr gut",
        good: "Gut",
        ok: "Okay",
        warn: "Prüfen"
      },
      tooltips: {
        noActivity: "Keine Aktivitätsdaten (Turnover=0)",
        activityPrefix: "Δ% Aktivität",
        turnoverPrefix: "Turnover"
      },
      dataSource: {
        preview: "Daten aus Vorschau-Berechnung",
        snapshot: "Daten aus Snapshot",
        live: "Live-Berechnung",
        timestamp: "Zeitpunkt"
      }
    }
  },
  
  en: {
    // General UI Elements
    language: "Language",
    analyze: "Analyze",
    calculate: "Calculate",
    walletConnected: "Wallet Connected",
    connectWallet: "Connect Wallet",
    editMode: "Edit Mode",
    applyChanges: "Apply Changes",
    cancel: "Cancel",
    save: "Save",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    reload: "recalculate",
    mainWallet: "Main Wallet",
    vedelegate: "veDelegate",
    plan: "Plan",
    
    // Navigation & Header
    home: "Home",
    analysis: "Analysis",
    settings: "Settings",
    export: "Export",
    myWallets: "My Wallets",
    manageActiveWallets: "Manage active wallets",
    "wallet.veworld.deepLinkDescription": "Direct login via VeWorld App",
    "wallet.veworld.qrCodeDescription": "Scan QR code with VeWorld",
    
    // Tax Tables
    taxSummary: "Tax Summary",
    totalProfit: "Total Profit",
    taxableProfit: "Taxable Profit",
    taxableProfitShort: "Taxable P/L",
    nonTaxableProfit: "Non-Taxable Profit",
    holdingPeriod: "Holding Period",
    purchasePrice: "Purchase Price",
    salePrice: "Sale Price",
    profit: "Profit",
    loss: "Loss",
    
    // Token-specific terms
    vet: "VET",
    vtho: "VTHO",
    b3tr: "B3TR",
    vip180: "VIP-180",
    nft: "NFT",
    token: "Token",
    vip180TokenTransfers: "VIP-180 Token Transfers",
    allTokens: "All Tokens",
    allTypes: "All Types",
    showMainWallet: "Show Main Wallet",
    showDelegateWallet: "Show VeDelegate Wallet",
    transfersShown: "transfers shown",
    ofTotal: "of total",
    noTokenTransfers: "No Token Transfers Found",
    transfersLoading: "Transfers are loading",
    
    // Transaction types
    received: "Received",
    sent: "Sent",
    swap: "Swap",
    swapIn: "Swap In",
    swapOut: "Swap Out",
    airdrop: "Airdrop",
    governanceReward: "Governance Reward",
    stakingReward: "Staking Reward",
    mint: "Mint",
    sale: "Sale",
    purchase: "Purchase",
    
    // Tax Categories
    disposalTransactions: "Disposal Transactions (§23 EStG)",
    otherIncome: "Other Income (§22 Nr. 3 EStG)",
    generated: "Generated",
    stakingRewards: "Staking Rewards",
    fees: "Fees",
    none: "None",
    freigrenze: "Threshold",
    gesamt: "Total",
    steuerlicheHinweise: "Disposal transactions and other income are taxed separately",
    
    // Country-specific tax categories
    disposalTransactionsDE: "Disposal transactions (German Income Tax Act: §23 EStG)",
    otherIncomeDE: "Other income (German Income Tax Act: §22 No. 3 EStG)",
    disposalTransactionsGR: "Capital Gains (Disposal Transactions)",
    otherIncomeGR: "Income from Staking, Airdrops, Rewards",
    disposalTransactionsIT: "Capital Gains (Plusvalenze)",
    otherIncomeIT: "Income from Staking, Airdrops, Rewards (Redditi)",
    disposalTransactionsGeneric: "Capital Gains / Disposal Transactions",
    otherIncomeGeneric: "Other Income (Staking, Airdrops, Rewards)",
    
    // FIFO-specific terms
    fifoAssignment: "FIFO Assignment",
    used: "Used",
    receivedOn: "Received On",
    holdingDuration: "Holding Duration",
    purchasePriceEUR: "Purchase €",
    salePriceEUR: "Sale €",
    profitEUR: "Profit €",
    taxable: "Taxable",
    holdingPeriodOver365Days: "Holding Period > 365 Days?",
    markAsNonTaxable: "Mark as non-taxable (holding period > 365 days)",
    note: "💡 Note: Mark inflows with \"holding period > 365 days\" as non-taxable",
    
    // Warnings & Notes
    warning: "Warning",
    attention: "Attention",
    incomplete: "Incomplete coverage: Missing tokens for complete coverage.",
    timeInconsistent: "⚠️ Warning: Token was received after swap/mint! Time inconsistent.",
    
    // Export & Data
    exportData: "Export Data",
    exportCSV: "Export CSV",
    exportPDF: "Export PDF",
    download: "Download",
    all: "all",
    taxData: "tax data",
    noDataToExport: "No data available for export.",
    markManually: "Mark manually",
    noSaleDataAvailable: "No sale data available",
    noMatchingPurchaseFound: "No matching purchase found",
    taxAssessmentForSale: "Tax assessment for sale",
    tip: "Tip",
    markNftSalesAsNonTaxable: "Mark NFT sales as \"non-taxable\" if held for more than 365 days",
    imprint: "Imprint",
    legalNotice: "Information according to § 5 TMG",
    allRightsReserved: "All rights reserved",
    
    // VTHO-specific terms
    vthoOverview: "VTHO Overview",
    generatedVtho: "Generated VTHO",
    stargateStaking: "Stargate Staking",
    taxTransactions: "Tax Transactions",
    gasConsumption: "Gas Consumption",
    
    // Table Headers
    type: "Type",
    comment: "Comment",
    to: "to",
    
    // VTHO-specific terms
    vthoOtherIncome: "Other Income (§)",
    unburnedTransactions: "Unburned Transactions",
    fees: "Fees",
    burnedAsGas: "Burned as Gas (Business expenses possible)",
    generated: "Generated",
    fromVetHolding: "from VET Holding",
    vetHoldingBalanceLabel: "VET balance:",
    dailyCalculatedEarnings: "Daily calculated earnings",
    receivedPlusGeneratedMinusUsedMinusSent: "Received + Generated – Used – Sent",
    
    // Tax Notes
    stargateUpgradeInfo: "Since 01.07.2025 (Stargate Upgrade), VTHO generation only occurs through active NFT staking.",
    lastUpdate: "Last Update",
    taxNotes: "Tax Notes",
    receivedTaxNote: "Counts as other income at daily rate (€).",
    usedTaxNote: "VTHO (\"Fees\") can count as business expenses.",
    generatedTaxNote: "Model earnings from VET holding – taxable.",
    syntheticVthoExplainTitle: "Why so many “Generated” rows?",
    syntheticVthoExplainBody:
      "These are not on-chain transactions. VTHO from VET holdings is modeled over time (0.000432 VTHO per VET per day). Whenever VTHO leaves the wallet – e.g. as gas – the prior period is closed so FIFO can use the VTHO accrued until then. Each slice is a taxable income line; the “Taxable P/L” column shows income (market value), not a disposal gain.",
    syntheticVthoExplainCount: "Synthetic slices in this tax year",
    syntheticVthoIncomeColumnHint: "Income (§22)",
    balanceTaxNote: "Received + Generated – Used – Sent",
    
    // NFT-specific terms
    nftName: "NFT Name",
    tokenId: "Token ID",
    project: "Project",
    contract: "Contract",
    currency: "Currency",
    
    // Time & Date
    days: "Days",
    date: "Date",
    time: "Time",
    price: "Price",
    for: "for",
    in: "in",
    
    // Status & Icons
    yes: "Yes",
    no: "No",
    pending: "Pending",
    completed: "Completed",
    failed: "Failed",
    
    // Balance & Verification
    balance: "Balance",
    balanceVerification: "Balance Verification",
    expectedBalance: "Expected Balance",
    actualBalance: "Actual Balance",
    difference: "Difference",
    blockchainBalanceCheck: "Blockchain Balance Check",
    checkingWalletBalance: "Checking current wallet balance",
    updatingBalanceCheck: "Updating balance check",
    fifoPoolsUpdated: "FIFO pools updated",
    calculated: "Calculated",
    blockchain: "Blockchain",
    usedGasFees: "Used Gas Fees",
    deviation: "Deviation",
    stargateCorrection: "Stargate correction considered",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    noRelevantDeviation: "No relevant deviation – directly usable for tax purposes",
    slightDeviation: "Slight deviation (1–3% and over €10) – usually unproblematic for tax purposes, but verifiable",
    criticalDeviation: "Deviation over 3% and over €500 – critical for tax purposes, please check FIFO pools",
    balanceError: "Error at /live-balance",
    connectionError: "Connection error",
    
    // Edit Mode specific terms
    editModeActive: "Edit Mode Active",
    manualClassification: "Manual Classification",
    changeClassification: "Change Classification",
    originalClassification: "Original Classification",
    newClassification: "New Classification",
    
    // Non-taxable markings
    markNonTaxable: "Mark as non-taxable",
    unmarkNonTaxable: "Mark as taxable",
    nonTaxableInflow: "Non-taxable inflow",
    nonTaxableSale: "Non-taxable sale",
    
    // Debug & Developer
    debug: "Debug",
    developerMode: "Developer Mode",
    showDebugInfo: "Show Debug Info",
    hideDebugInfo: "Hide Debug Info",
    
    // Error messages
    errorLoadingData: "Error loading data",
    errorSavingData: "Error saving data",
    errorCalculatingFifo: "Error calculating FIFO",
    errorExportingData: "Error exporting data",
    
    // Success messages
    dataLoadedSuccessfully: "Data loaded successfully",
    changesSavedSuccessfully: "Changes saved successfully",
    fifoCalculatedSuccessfully: "FIFO calculated successfully",
    dataExportedSuccessfully: "Data exported successfully",

    // Toasts (react-toastify)
    toast: {
      geo: {
        blocked:
          "Location access for this website is blocked in the browser – purchase cancelled. For tax determination of the place of supply (EU VAT) we need two independent proofs (e.g. IP country and GPS country). Please allow access to approximate location (country) in your browser settings (e.g. Edge: Settings → Site permissions → Location → your site → Allow) and start the purchase again.",
        permissionDenied:
          "Location access denied – purchase cancelled. Please allow location access in your browser settings and try again.",
        unavailable:
          "Location is currently unavailable – purchase cancelled. Please check your browser/device settings and try again.",
        timeout:
          "Location request took too long – purchase cancelled. Please check your connection/reception and try again.",
        backendUnreachable:
          "Country verification failed – purchase cancelled. The location service is currently unavailable. Please try again later.",
        policyViolation:
          "Under EU VAT rules we need at least two independent location proofs (IP + GPS) to determine the place of supply. Please allow location access and try again.",
        unknown:
          "Location verification failed – purchase cancelled. Please check your settings and try again.",
        infoBeforePrompt:
          "Note: We only verify your country for tax purposes. Exact coordinates are not stored.",
      },
      noTaxYearSelected: "No tax year detected – please select a year.",
      datasetIdMissing: "Dataset ID missing – please try again.",
      addressCopied: "Address copied",
      addressCopiedExclaim: "Address copied!",
      hashCopied: "Hash copied!",
      copyFailed: "Copy failed",
    },
    
    // Placeholders & Default values
    unknown: "Unknown",
    notAvailable: "Not Available",
    loadingData: "Loading data...",
    noDataAvailable: "No data available",
    
    // Tooltips & Help texts
    help: "Help",
    tooltip: "Tooltip",
    moreInfo: "More Information",
    clickForDetails: "Click for details",
    
    // Confirmations
    confirm: "Confirm",
    confirmDelete: "Confirm Delete",
    confirmSave: "Confirm Save",
    confirmCancel: "Confirm Cancel",
    
    // Filter & Search
    filter: "Filter",
    search: "Search",
    clearFilter: "Clear Filter",
    applyFilter: "Apply Filter",
    
    // Sorting
    sort: "Sort",
    sortBy: "Sort By",
    ascending: "Ascending",
    descending: "Descending",
    
    // Pagination
    page: "Page",
    of: "of",
    itemsPerPage: "Items per page",
    showAll: "Show All",
    
    // Statistics
    statistics: "Statistics",
    total: "Total",
    average: "Average",
    minimum: "Minimum",
    maximum: "Maximum",
    count: "Count",
    
    // Time periods
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    thisMonth: "This Month",
    thisYear: "This Year",
    lastYear: "Last Year",
    
    // Currencies
    euro: "Euro",
    usd: "US Dollar",
    currency: "Currency",
    
    // Tax years
    taxYear: "Tax Year",
    selectTaxYear: "Select Tax Year",
    
    // Wallet & Addresses
    wallet: "Wallet",
    walletAddress: "Wallet Address",
    address: "Address",
    copyAddress: "Copy Address",
    
    // Transactions
    transaction: "Transaction",
    transactions: "Transactions",
    transactionHash: "Transaction Hash",
    txHashColumn: "TX Hash",
    blockNumber: "Block Number",
    gasFee: "Gas Fee",
    blockchainTransactions: "Blockchain Transactions",
    loadingTransactions: "Loading transactions",
    noTransactionsFound: "No transactions found",
    pleaseAdjustFilters: "Please adjust filters or search.",
    amount: "Amount",
    lpDepositColumn: "Deposit",
    lpWithdrawColumn: "Withdraw",
    tokensColumnSub: "Tokens",
    recipient: "Recipient",
    sender: "Sender",
    source: "Source",
    exchange: "Exchange / Source",
    exchangeKind: "Type",
    quote: "Quote",
    side: "Side",
    txid: "TXID",
    fee: "Fee",
    feeAsset: "Fee Asset",
    quoteAmount: "Quote Amount",
    exchangeSource: "Source",
    exchangeType: "Type",
    exchangeBuySell: "Buy / Sell",
    
    // Validation
    validation: "Validation",
    valid: "Valid",
    invalid: "Invalid",
    required: "Required",
    optional: "Optional",
    
    // Permissions
    permissions: "Permissions",
    accessDenied: "Access Denied",
    insufficientPermissions: "Insufficient Permissions",
    
    // Network
    network: "Network",
    mainnet: "Mainnet",
    testnet: "Testnet",
    connectionStatus: "Connection Status",
    connected: "Connected",
    disconnected: "Disconnected",
    
    // Synchronization
    sync: "Sync",
    syncing: "Syncing...",
    syncComplete: "Sync Complete",
    syncFailed: "Sync Failed",
    
    // Cache & Performance
    cache: "Cache",
    clearCache: "Clear Cache",
    refresh: "Refresh",
    reload: "Reload",
    
    // Settings
    settings: "Settings",
    preferences: "Preferences",
    appearance: "Appearance",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    
    // Notifications
    notifications: "Notifications",
    notificationSettings: "Notification Settings",
    enableNotifications: "Enable Notifications",
    disableNotifications: "Disable Notifications",
    
    // Help & Support
    help: "Help",
    support: "Support",
    documentation: "Documentation",
    contact: "Contact",
    feedback: "Feedback",
    
    // About the App
    about: "About",
    version: "Version",
    credits: "Credits",
    license: "License",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    
    // Edit Mode
    activate: "activate",
    leave: "leave",
    totalPurchasePrice: "Total purchase price",
    
    // Landing Page (App.jsx)
    ultimateAioWalletAnalysis: "VeChain: Ultimate AIO Wallet Analysis",
    enterWalletAddressDescription: "Enter your VeChain wallet addresses to determine your taxable income.",
    pricingAndFeatures: "Pricing & Features",
    selectPlan: "Select plan",
    selectYear: "Select year",
    selectPaymentMethod: "Select payment method",
    selectResidence: "Tax rules",
    vetPayment: "VET (VeChain)",
    creditCardPayment: "Credit Card",
    analyze: "Analyze",
    analyzing: "Analyzing...",
    buy: "Buy",
    fieldRequired: "Field required",
    walletAlreadyAnalyzed: "Wallet already analyzed",
    addWalletToList: "Add Wallet to List",
    insertNextWalletHint: "Insert next VeChain wallet for analysis",
    selectedWallets: "Selected Wallets",
    mainWallet: "MAIN WALLET",
    vedelegateWallet: "VEDELEGATE WALLET",
    noWalletAnalyzedYet: "No wallet analyzed yet",
    noVedelegateWalletDetected: "No veDelegate wallet detected.",
    transactionOverview: "Transaction Overview",
    transactions: "TRANSACTIONS",
    myWallets: "My Wallets",
    manageActiveWallets: "Manage active wallets",
    analysisDashboard: "Analysis Dashboard",
    viewTransactionAnalysis: "View transaction analysis",
    legalNotices: "Legal Notices",
    termsAndPrivacy: "Terms & privacy policy",
    helpAndSupport: "Help & Support",
    getHelpAndDocumentation: "Get help and documentation",
    
    // Navigation & Menu
    dashboard: "Dashboard",
    overview: "Overview",
    summary: "Summary",
    detailedView: "Detailed View",
    quickOverview: "Quick Overview",
    
    // Dashboard specific
    dashboardTitle: "Tax Overview Dashboard",
    dashboardSubtitle: "All calculated values in one glance",
    totalCalculatedValues: "Total values of all calculations",
    individualTableValues: "Individual table values",
    taxYearSummary: "Tax Year Summary",
    profitOverview: "Profit Overview",
    transactionSummary: "Transaction Overview",
    calculatedProfits: "Calculated Profits",
    totalTaxableAmount: "Total taxable amount",
    disposalTransactionsTotal: "Total Disposal Transactions",
    otherIncomeTotal: "Total Other Income",
    nftTransactions: "NFT Transactions",
    tokenTransactions: "Token Transactions",
    vetTransactions: "VET Transactions",
    vthoTransactions: "VTHO Transactions",
    b3trTransactions: "VIP-180 Token Transactions",
    
    // Specific labels for Tax Tables
    generatedVthoAndStakingRewards: "Generated VTHO and Stargate Staking Rewards",
    airdropsAndGovernanceRewards: "Airdrops and Governance Rewards",
    swaps: "Swaps",
    nftPurchasesAndSales: "NFT Purchases & Sales",
    exchangeSells: "Sells",
    
    // Balance Verifier
    balanceVerifier: {
      title: "Balance check info",
      statusLegend: "Status legend:",
      termExplanation: "Definitions:",
      tableHeaders: {
        token: "Token",
        onchain: "On-chain",
        onchainSub: "Wallet balance",
        fifo: "FIFO",
        fifoSub: "(incl. exchanges)",
        delta: "Δ",
        deltaSub: "(difference)",
        activity: "Activity",
        activitySub: "Turnover + Δ/Turnover",
        status: "Status",
        deltaBalance: "Δ%",
        deltaPctBalance: "Δ% Balance",
        deltaBalanceSub: "(balance)",
        deltaActivity: "Δ%",
        deltaActivitySub: "(activity)",
        rating: "Rating"
      },
      labels: {
        walletOnly: "Wallet-only",
        relativeToWalletOnly: "relative to Wallet-only FIFO",
        fifoFullShort: "Full:"
      },
      status: {
        match: "✓ Match",
        onchainHigher: "↑ On-chain higher",
        fifoHigher: "↓ FIFO higher"
      },
      summary: {
        tokensCompared: "Tokens compared:",
        hidden: "hidden",
        matches: "Matches:",
        onchainHigher: "On-chain higher:",
        fifoHigher: "FIFO higher:"
      },
      actions: {
        recheck: "🔄 Recheck",
        checking: "⏳ Checking..."
      },
      toggles: {
        cleanView: "Clean view (hide dust)",
        includeStakedVet: "Include Stargate staked VET"
      },
      terms: {
        onchainApi: "On-chain (API)",
        onchainReported: "On-chain (Reported)",
        fifoCalc: "FIFO (calculation)",
        fifoCalculated: "FIFO (Calculated)",
        deltaBalance: "Δ% (balance)",
        deltaDifference: "Δ (Difference)",
        deltaActivity: "Δ% (activity)",
        activityTurnover: "Turnover (activity)",
        deltaTurnover: "Δ/Turnover",
        score: "Score (0–100)"
      },
      descriptions: {
        onchainApi: "Actual wallet balance queried live via blockchain API (wallets in this set only).",
        onchainReported: "Current wallet balance, queried live via blockchain API. Includes wallets only, not exchanges.",
        fifoCalc: "Calculated balance from all captured events/trades — including exchange balances from CSV imports.",
        fifoCalculated: "Calculated end balance from all recorded transactions (trades, transfers, staking, airdrops, NFTs). This is the basis for tax calculation.",
        deltaBalance: "Percent deviation between API balance and FIFO calculation relative to the ending balance (can be misleading for tiny leftovers).",
        deltaDifference: "Deviation between on-chain snapshot and calculated FIFO balance. A deviation can occur due to missing data, exchange transactions, or API limitations.",
        deltaActivity: "Percent deviation between API balance and FIFO calculation relative to total activity (turnover = total inflows + outflows, excluding internal transfers). This provides a robust quality metric across the full history.",
        activityTurnover: "Total movement volume of the token in the wallet set (inflows + outflows, excluding internal transfers).",
        deltaTurnover: "Shows the difference between on-chain and FIFO as a percentage of total movement (turnover). This helps judge whether a balance gap is material relative to the activity.",
        score: "Quality indicator for assessing data consistency between on-chain snapshot and calculated history. The score considers both end balance and movement volume."
      },
      legalNotice: {
        title: "⚠️ Legal Notice:",
        text: "The reconciliation score serves solely as a technical data and completeness indicator. It does not constitute tax advice and does not guarantee tax correctness. The user is solely responsible for tax liability."
      },
      hintTitle: "💡 Note:",
      hintText: "If FIFO is higher than On-chain, that's often expected when assets are held on exchanges (included in FIFO, not visible in wallet API).",
      ratings: {
        na: "No data",
        great: "Great",
        good: "Good",
        ok: "Okay",
        warn: "Check"
      },
      tooltips: {
        noActivity: "No activity data (turnover=0)",
        activityPrefix: "Δ% activity",
        turnoverPrefix: "Turnover"
      },
      dataSource: {
        preview: "Data from preview calculation",
        snapshot: "Data from snapshot",
        live: "Live calculation",
        timestamp: "Timestamp"
      }
    }
  }
};

/** Aktuelle UI-Sprache für Toasts außerhalb von React (z. B. Geo vor Kauf) – synchron mit LanguageContext/localStorage */
export function getUiLanguage() {
  try {
    const v = localStorage.getItem('v3tax-language');
    return v === 'de' ? 'de' : 'en';
  } catch {
    return 'en';
  }
}

/**
 * Gleiche Logik wie überall in der UI: nur exakt 'en' → Englisch, sonst Deutsch.
 * Verhindert, dass t() bei null/leerem/unbekanntem language auf Englisch zurückfällt (wie früher translations[language] || en).
 */
export function normalizeLang(language) {
  return language === 'en' ? 'en' : 'de';
}

// 🌐 Hilfsfunktion zum Abrufen von Übersetzungen
export const t = (key, language = 'de') => {
  const lang = normalizeLang(language);
  const langDict = translations[lang] || translations['en'] || {};

  // nested key resolution
  if (typeof key === 'string' && key.includes('.')) {
    const parts = key.split('.');
    let cur = langDict;
    for (const p of parts) {
      if (cur && typeof cur === 'object' && p in cur) cur = cur[p];
      else { cur = undefined; break; }
    }
    if (typeof cur === 'string') return cur;
  }

  // flat fallback
  if (langDict[key]) return langDict[key];

  // fallback EN nested
  const en = translations['en'] || {};
  if (typeof key === 'string' && key.includes('.')) {
    const parts = key.split('.');
    let cur = en;
    for (const p of parts) {
      if (cur && typeof cur === 'object' && p in cur) cur = cur[p];
      else { cur = undefined; break; }
    }
    if (typeof cur === 'string') return cur;
  }
  return en[key] || key;
};

// 🌐 Funktion zum Bestimmen der Standardsprache basierend auf Land
export const getDefaultLanguage = (country) => {
  const germanCountries = ['germany', 'deutschland', 'de'];
  const italianCountries = ['italy', 'italien', 'it'];
  const lowerCountry = country?.toLowerCase();
  
  if (germanCountries.includes(lowerCountry)) {
    return 'de';
  } else if (italianCountries.includes(lowerCountry)) {
    return 'en'; // Italien verwendet Englisch als Standard
  }
  
  return 'en'; // Standard für alle anderen Länder (und wenn kein Land angegeben)
};

// 🌐 Funktion für länder-spezifische Steuerkategorien
export const getTaxCategoryLabel = (category, country, language = 'de') => {
  const countryCode = country?.toUpperCase() || 'GENERIC';
  const lang = language || getDefaultLanguage(country);
  
  // Spezifische Länder-Bezeichnungen
  if (countryCode === 'DE') {
    return t(category === 'disposal' ? 'disposalTransactionsDE' : 'otherIncomeDE', lang);
  } else if (countryCode === 'GR') {
    return t(category === 'disposal' ? 'disposalTransactionsGR' : 'otherIncomeGR', lang);
  } else if (countryCode === 'IT') {
    return t(category === 'disposal' ? 'disposalTransactionsIT' : 'otherIncomeIT', lang);
  }
  
  // Generische Bezeichnungen für alle anderen Länder
  return t(category === 'disposal' ? 'disposalTransactionsGeneric' : 'otherIncomeGeneric', lang);
};

// 🌐 Verfügbare Sprachen
export const availableLanguages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇺🇸' }
]; 